import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import {pink} from "@mui/material/colors";
import DynamicStepContent from "./components/steps/DynamicStepContent";
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {useContext} from "react";
import StepperContext from "./components/steps/StepperContext";
import {TechnicalEngagementProvider} from "./components/TechnicalEngagementContext";


const themeProps = {
    typography: {
        fontSize: 30
    },

    palette: {
        primary: {
            main: pink[500]
        },
    },
}

const stepperTheme = createTheme({...themeProps});



const steps = [
    {
        label: 'Select Environment Type',
    },
    {
        label: 'Complete Request Form',
    },
    {
        label: 'Select Blueprint',
    },
];

export default function VerticalLinearStepper() {
    const {activeStep} = useContext(StepperContext);

    return (
        <ThemeProvider theme={stepperTheme}>
            <Box sx={{maxWidth: 600}}>
                <TechnicalEngagementProvider>
                    <Stepper activeStep={activeStep} orientation="vertical">
                        {steps.map((step, index) => (
                            <Step key={step.label}>
                                <StepLabel>
                                    <h6>{step.label}</h6>
                                </StepLabel>
                                <StepContent>
                                    <DynamicStepContent
                                        index={index}
                                    />
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                </TechnicalEngagementProvider>
            </Box>
        </ThemeProvider>
    );
}
